import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';
const _ = require('lodash');

function checkCat(categories, cat, path, excludePath) {
	//console.log(categories);
	//console.log(cat);
	var found = 0;
	if (categories != null) {
		categories.forEach(function (category) {
			//console.log(category);
			if (category === cat && path !== excludePath) {
				found++;
			} else {
				//console.log("NOT found "+category+" "+cat);
			}

		});
	}

	if (found > 0) {
		return 1;
	} else {
		return 0;
	}

}
export default function LatestBlogPosts(props) {

	const data = useStaticQuery(graphql`
      query LatestBlogPostsQuery{
        allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___date] }
          limit: 100
          filter: {fileAbsolutePath: { regex: "/blog/" }  }
          
        ) {
          edges {
			node {
		  
			  frontmatter {
				title
				path
				postsummary
				featuredimage
				categories
			  }
			}
		  }
        }
      }
    `)
	const excludePath = props.excludePath ? props.excludePath : "";
	//filter out only the category we want 
	const posts = data.allMarkdownRemark.edges.filter(
		post => checkCat(post.node.frontmatter.categories, props.category, post.node.frontmatter.path, excludePath) === 1
	);

	const sectionClass = props.sectionClass ? "sectionSpacing " + props.sectionClass : "sectionSpacing";
	//props.category
	//console.log(posts);
	//console.log(props.category);

	const categoryPath = `/blog/${_.kebabCase(props.category)}/`;
	// console.log("Latest Blog Post Console", categoryPath);
	return (
		<section className={sectionClass}>
			<h2 className="text-center"><Link className="categoryLink" to={categoryPath}>{props.category} </Link></h2>
			<div className="blogCardWrapper contentBlock">
				{posts.map((post, index) => {
					if (index < 3) {
						return (
							<div className="blogCards" key={post.node.frontmatter.path}>
								<a target="_blank" href={post.node.frontmatter.path}>
									<div>
										<img src={post.node.frontmatter.featuredimage} alt={post.node.frontmatter.title} />
									</div>
									<div className="sectionSpacing">
										{<p className="blogTaxonomy text-decoration-none">{props.category}</p>}
										<p>{post.node.frontmatter.title}</p>
										<p>{post.node.frontmatter.postsummary}</p>
									</div>
								</a>
							</div>
						)
					}
					return (
					""
					);
				}
				)}
			</div>
			<div className="buttonContent">
				<center><a className="button mt-3" rel="noopener noreferrer" target="_blank" href={categoryPath}>SEE MORE</a></center>
			</div>
		</section>
	)
}
